module.exports = __webpack_public_path__ + "static/media/cobros.e69bd8a3.svg";